import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import styled from 'react-emotion';

import { Label } from '~/modules/coreUI/components/basic/Labels';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';

const Summary = styled.pre`
  white-space: pre-wrap;
  line-height: 1.2;
`;

const ProductSummary = ({ summary }) => (summary ? (
  <Fragment>
    <Label size={['md', 'lg']} important semiBold>{i18next.t('ecommerceCoreUI:Product.productSummary')}</Label>
    <Spacer size={1.5} />
    <Summary><Label sm>{summary}</Label></Summary>
  </Fragment>
) : null);

ProductSummary.propTypes = {
  summary: PropTypes.string.isRequired,
};

export default ProductSummary;
